import type { JSX } from 'react'

export const AudioIcon = (): JSX.Element => (
  <use href='#audioIcon' height='100%' width='100%' />
)
